<template>
<InputSelector :label="t('Filter')" v-model="filter" :tabindex="tabindex"/>
</template>

<script>
import InputSelector from './../selectors/InputSelector.vue';
import i18n from '../../i18n';

export default {
    name: 'InstrumentFilter',

    components: {
        InputSelector
    },

    computed: {
        filter: {
            get () {
                return this.$store.state.filter;
            },
            set (filter) {
                this.$store.commit('setFilter', { filter });
            }
        },

        tabindex () {
            if (this.disabled) {
                return null;
            }
            if (this.$store.getters.mediaQuery.includes(720)) {
                return 4;
            }
            return 5;
        }
    },

    methods: {
        t (str) {
            return i18n(str, this.$store.state.lang);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/filters/InstrumentFilter.vue